import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";

export interface DashboardAnalyticsParams {
  periodType?: string;
  role?: string;
  region?: string;
  categoryId?: string;
  serviceType?: string;
  ageBand?: string;
}

export interface DashboardSummaryMetrics {
  activeUsers: number;
  bookingsToday: number;
  revenueYtd: number;
  totalBusinesses: number;
}

export interface DashboardChartSeries {
  labels: string[];
  userGrowth: number[];
  revenue: number[];
}

export interface DashboardLabelValue {
  label: string;
  value: number;
}

export interface DashboardTopService {
  name: string;
  revenue: number;
}

export interface DashboardHeatmapPoint {
  x: string;
  y: number;
}

export interface DashboardHeatmapSeries {
  name: string;
  data: DashboardHeatmapPoint[];
}

export interface DashboardActivityHeatmap {
  days: string[];
  hours: string[];
  series: DashboardHeatmapSeries[];
}

export interface DashboardAnalyticsResponse {
  summary: DashboardSummaryMetrics;
  charts: DashboardChartSeries;
  paymentMethods: DashboardLabelValue[];
  topServices: DashboardTopService[];
  activityHeatmap: DashboardActivityHeatmap;
}

export class DashboardService {
  async getAnalytics(params?: DashboardAnalyticsParams) {
    return apiService.get("/dashboard/analytics", {
      params: sanitizeQueryParams(params || {}),
    });
  }
}

export const dashboardService = new DashboardService();
